import { styled } from '@stitches/configed';
import { Layout as LayoutAntd } from 'antd';
import { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useIsMounted from '../../hooks/useIsMounted';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import Header from './Header';
import MainWraper from './MainWraper';
import RouteContext from './RouteContext';
import Sidebar from './Sidebar';
import { Profile } from './UserInfo';
import NavContextProvider from './NavContext';

const ContentStyled = styled(LayoutAntd.Content, {
  variants: {
    // (mobile) fix height website when sidebar open
    collapsed: {
      false: {
        height: '100vh',
        '@xs': {
          height: 'auto',
        },
      },
    },
  },
});

export type RouterType = {
  badge?: number | null;
  badgeLoading?: boolean;
  path: string;
  name: string;
  redirect?: string;
  layout?: boolean;
  icon?: ReactNode;
  component?: ReactNode;
  hideInMenu?: boolean;
  hideChildrenInMenu?: boolean;
  hideBreadcrumb?: boolean;
  routes?: RouterType[];
  nameBlock?: string;
  badgeName?: string
};
type Props = {
  currentUser?: Profile;
  routes: RouterType[];
  showableRoutes?: string[];
  rightHeader?: ReactNode;
  customItemSidebar?: ReactNode;
  children: ReactNode;
  typeApp: 'merchant' | 'admin';
  countState?: Record<string, any>;
};
const Layout = ({
  currentUser,
  routes,
  showableRoutes,
  rightHeader,
  children,
  customItemSidebar,
  typeApp,
  countState
}: Props) => {
  const [collapsed, setCollapsed] = useState(false);
  const [hiddenSidebar, setHiddenSidebar] = useState(true); // fix default sibar not collapsed
  const isMounted = useIsMounted();
  const isMobile = useMediaQuery('(max-width: 480px)');
  const isLG = useMediaQuery('(max-width: 1024px)');

  const [mobileRightHeader, setMobileRightHeader] = useState<ReactNode>();
  const [pageName, setPageName] = useState<string>();

  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter((i) => i);
  const objRouter = routes.find(
    (x) => x.path === '/' + location.pathname.split('/')[1],
  );

  const f = (path: string) => {
    const rootRoute = routes.find((x) => x.path === path);
    if (!rootRoute) return {};
    const map: Record<string, string> = {
      [path]: rootRoute?.name,
    };

    const convertToBreadcrumbMap = (
      parentPath: string,
      routes: RouterType[],
    ) => {
      routes.forEach((x) => {
        const arrLocationPathname = location.pathname.split('/');
        // remove reference array values.routes
        let path = x.path;
        const name = x.name;
        if (/^\/:/.test(path)) {
          path = '/' + arrLocationPathname[arrLocationPathname.length - 1];
        }
        // if (dynamicRoutesMap) {
        //   const l = dynamicRoutesMap[x.path];
        //   if (l) {
        //     path = '/' + l.path || '';
        //     name = l.name || '';
        //   }
        // }
        const newPath = parentPath + path;
        map[newPath] = name;
        if (x.routes) {
          convertToBreadcrumbMap(newPath, x.routes);
        }
      });
    };
    if (rootRoute?.routes)
      convertToBreadcrumbMap(rootRoute.path, rootRoute.routes);
    return map;
  };
  const breadcrumbNameMap = f('/' + pathSnippets[0]);

  useEffect(() => {
    setHiddenSidebar(false);
  }, [isMounted]);
  if (objRouter?.layout === false)
    return (
      <RouteContext.Provider value={{ routes: routes, isMobile }}>
        <MainWraper>{children}</MainWraper>
      </RouteContext.Provider>
    );

  const arrLocationPathname = location.pathname.split('/');
  const parentPath = arrLocationPathname[arrLocationPathname.length - 2];

  return (
    <RouteContext.Provider
      value={{
        routes: routes,
        pageName: breadcrumbNameMap[location.pathname],
        breadcrumbNameMap: breadcrumbNameMap,
        mobileRightHeader,
        setMobileRightHeader,
        setPageName,
        isMobile,
        menuCollapsed: collapsed,
      }}
    >
      <NavContextProvider>
        <MainWraper>
          <LayoutAntd>
            <Sidebar
              currentUser={currentUser}
              routes={routes}
              showableRoutes={showableRoutes}
              collapsed={collapsed}
              hidden={hiddenSidebar}
              toggleCollapsed={() => setCollapsed(!collapsed)}
              customItemSidebar={customItemSidebar}
              typeApp={typeApp}
              countState={countState}
            />
            <LayoutAntd>
              <Header
                heading={
                  pageName ? pageName : breadcrumbNameMap[location.pathname]
                }
                toggleCollapsed={() => setCollapsed(!collapsed)}
                rightHeader={isLG ? mobileRightHeader : rightHeader}
                goBack={parentPath}
              />
              <ContentStyled collapsed={collapsed}>{children}</ContentStyled>
            </LayoutAntd>
          </LayoutAntd>
        </MainWraper>
      </NavContextProvider>
    </RouteContext.Provider>
  );
};
export default Layout;
